import { isDirectOnlyAdministrator } from '../Utils/NotificationPreferences'

export const shouldRefreshAlerts = (user, event, adminMode) =>
  Boolean(
    user?._id &&
      !isDirectOnlyAdministrator(user, adminMode) &&
      event?.to?.includes(user?.role)
  )

export const shouldNotifyAlert = (user, event, adminMode) => {
  const notificationRecipients = event?.notifyTo || event?.to

  return Boolean(
    user?._id &&
      user?._id !== event?.userId &&
      !isDirectOnlyAdministrator(user, adminMode) &&
      notificationRecipients?.includes(user?.role)
  )
}
